import React from 'react';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { FormMicSample } from './FormMicSample';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalMicSample = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name, handleInputChange,
        validaciones, saveCreate, saveUpdate,
        closeDialog,

    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-chicken f-26"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {"Muestras"}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >

            {
                method === "create"
                    ?
                    <FormMicSample
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicSample
                            button={ModalButtonUpdate}
                            {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveUpdate, name, }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}
